import { graphql, useStaticQuery } from 'gatsby';
import React, { FC } from 'react';

import { keysToCamel } from '@utils/butter';

import { AuthStep, AuthStepContext } from '@providers/AuthProvider';

import TOTPCodeInputForm, { ITOTPCodeInputFormContent } from './TOTPCodeInputForm.component';

interface ITOTPCodeInputFormPageProps {
	authStep: AuthStepContext;
	setAuthStep: (authStep: AuthStepContext) => void;
	onComplete: () => void;
}

const TOTPCodeInputFormPage: FC<ITOTPCodeInputFormPageProps> = ({
	authStep,
	setAuthStep,
	...props
}) => {
	const { pageContent } = useStaticQuery(
		graphql`
			{
				pageContent: butterPage(slug: { eq: "totp-code-input-form" }) {
					setup {
						title
						description
					}
					enrolled {
						title
						description
					}
				}
			}
		`
	);

	const refinedContent: ITOTPCodeInputFormContent = keysToCamel({
		...pageContent,
		...(authStep.nextStep === AuthStep.needTOTPMultifactorSetup && 'secretCode' in authStep
			? pageContent.setup
			: pageContent.enrolled),
	}) as ITOTPCodeInputFormContent;

	return (
		<TOTPCodeInputForm
			authStep={authStep}
			setAuthStep={setAuthStep}
			pageContent={refinedContent}
			{...props}
		/>
	);
};

export default TOTPCodeInputFormPage;
